import partnerActivityProviders from "../../../../server/lib/open-planet/partnerActivityProviders";

export default function fullItineraryLink(poi) {
  return poi.provider === partnerActivityProviders.gadventures.id && poi.links.booking ?
    `${poi.links.booking.split("?")[0]}itinerary/?${poi.links.booking.split("?")[1]}` :
    "";
}



// WEBPACK FOOTER //
// ./assets/pois/utils/fullItineraryLink.js